<template>
  <div class="login-icon"></div>
</template>

<script>
import auth from "@/api/auth";
import Swal from "sweetalert2";
import { bus } from "@/main";

export default {
  name: "login_cliente",
  data() {
    return {
      login: "",
    };
  },
  mounted(){
    bus.$emit("changeLoading", true);
    this.login = this.$route.query.hash;
    this.loginMethod();
  },
  methods:{
    loginMethod(){
      if(this.login){
        auth
        .loginHash(this.login)
        .then(data => {
          bus.$emit("changeLoading", false);
          window.location.href = '/';
          // location.reload();
        })
        .catch(error => {
          let msg = "";
          if (error.response.data.error == "Expired") {
            msg = "Sua conta esta expirada";
          }
          else if (error.response.data.error == "Blocked") {
            msg = "Seu usuário esta bloqueado";
          } else {
            msg =
              error.response.status == 418
                ? "Parece que o limite de logins já foi excedido, tente desconetar dos outros computadores."
                : "Parece que essas credencias não constam no sistema.";
          }
          bus.$emit("changeLoading", false);
          Swal.fire({
            title: "Tivemos um problema",
            text: msg,
            icon: "error"
          }).then( () => {
            this.$router.push({ name: "client.login" });
          } )
        });
      } else {
        bus.$emit("changeLoading", false);
        Swal.fire({
          title: "Ocorreu um erro",
          icon: "error"
        }).then( () => {
            this.$router.push({ name: "client.login" });
          } )
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/styles/General.scss";
</style>